import { IUser } from 'core-components/sitebuilder/models/IUser'
import MeasureController from 'core/analytics/MeasureController'
import { createNetworkDebugRecorder, isNetworkDebugUser } from 'shared/lib/networkDebug'

import { getJBPSettingsCrud } from '../common/helpers/getJBPSettingsCrud'

import { mapApiToJbpSettings } from './mappings/mapApiToJbpSettings'

const JBP_SETTINGS_ID = 1

export const fetchJBPSettings = async (user: IUser) => {
  const crud = getJBPSettingsCrud()
  const metrics = new MeasureController('JBPSettings', { startInitializationMeasure: false, user })
  const recorder = createNetworkDebugRecorder({
    enabled: isNetworkDebugUser(user?.roleIds),
    name: 'JBPSettings',
    kind: 'settings',
    method: 'GET',
    url: `CrudStore · JBPSettings · getById({ id: ${JBP_SETTINGS_ID}, keyField: "EntryId" })`,
    body: null,
    headers: {},
    target: 'state.partner360.jbpSettings.data',
  })
  let stage = 'request'

  try {
    metrics.start('renderData')
    const jbpSettingsApi = await crud.getById({ id: JBP_SETTINGS_ID, keyField: 'EntryId' })
    metrics.stop('renderData')
    recorder.step('request')
    stage = 'getById result'

    if (!jbpSettingsApi) {
      throw new Error('Failed to load JBPSettings')
    }

    stage = 'mapApiToJbpSettings'
    const mapped = mapApiToJbpSettings(jbpSettingsApi)
    recorder.step('mapApiToJbpSettings')
    recorder.finish({
      jsonBytes: JSON.stringify(jbpSettingsApi).length,
      raw: jbpSettingsApi,
      mapped,
    })
    recorder.measureStoreUpdate()

    return mapped
  } catch (e: unknown) {
    recorder.fail({ message: e instanceof Error ? e.message : String(e), stage })

    throw e
  }
}
